import { createTypes } from "../../utils/helpers";

const ROUTINE_GET_ENTITIES: any = createTypes('ROUTINE_GET_ENTITIES');
const ROUTINE_SET_EDITED = 'ROUTINE_SET_EDITED';
const ROUTINE_SET_EDITED_ROUTINE_DAYS = 'ROUTINE_SET_EDITED_ROUTINE_DAYS';
const ROUTINE_SET_ROUTINE_DAYS: any = createTypes('ROUTINE_SET_ROUTINE_DAYS');
const ROUTINE_SET_RESTAURANTS_ROUTINE_DAYS: any = createTypes('ROUTINE_SET_RESTAURANTS_ROUTINE_DAYS')

export {
    ROUTINE_GET_ENTITIES,
    ROUTINE_SET_EDITED,
    ROUTINE_SET_EDITED_ROUTINE_DAYS,
    ROUTINE_SET_ROUTINE_DAYS,
    ROUTINE_SET_RESTAURANTS_ROUTINE_DAYS
}
